// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".about-logo-container {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  height: 153px;\n}\n.about-logo {\n  width: 100px;\n  height: 100px;\n}\n.about-modal-content > .modal-body {\n  padding-top: 0px;\n}\n.about-details {\n  padding-top: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
